/**
 * Třída slouží k vytvoření klikatelného odkazu k otevření souboru dokumentu.
 *
 * Použití:
 * <SouborLink onClick={handleOnClick} soubor={soubor} hlavni={hlavni} />
 */
import React from 'react';
import AbstractReactComponent from "../AbstractReactComponent";
import {DropdownItem} from "reactstrap";
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import SouborApi from "../api/gen/dokumenty/SouborApi";
import DokumentSoubor from "../api/gen/proxioapi/decls/DokumentSoubor";
import FixedDropDownButton from "../fixed-dropdown-button/FixedDropDownButton";
import ActionsRow from "../detail/ActionsRow";
import Icon from "../icon/FAIcon";
import * as modal from "../modal";

class SouborLink extends AbstractReactComponent {

    static formName = 'souborLink';

    static propTypes = {
        onClick: React.PropTypes.func.isRequired,
        soubor: React.PropTypes.instanceOf(DokumentSoubor).isRequired,
        hlavni: React.PropTypes.bool
    };

    static defaultProps = {
        hlavni: false
    };

    handleSmazatSoubor = () => {
        const {soubor} = this.props;
        this.dispatch(
            modal.ModalActions.showConfirm(
                "Smazání přílohy",
                "Opravdu chcete smazat přílohu?",
                () => {
                    SouborApi.deleteDokumentSoubor(soubor.id);
                },
                null,
                "Smazat"
            )
        );
    };

    renderActions = () => {
        return <FixedDropDownButton color="action" noCaret id="soubor-actions-dropdown" title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem type="button" key="1" onClick={this.handleSmazatSoubor}>Smazat</DropdownItem>
        </FixedDropDownButton>
    };

    render() {
        const {soubor, onClick, hlavni} = this.props;

        return <ActionsRow actions={this.renderActions()}>
            <a href="#" onClick={onClick}>{hlavni ? <strong>{soubor.jmenoSoubor}</strong> : soubor.jmenoSoubor}</a>
        </ActionsRow>
    }
}

const reduxFormObj = reduxForm({
    form: SouborLink.formName
})(SouborLink);

export default connect()(reduxFormObj);
